function WordListArea(props: any) {
  let myProps = {
    Style: {},
    templete_data_json: {},
    ...props
  };
  let Style = myProps.Style || {};
  let templete_data_json = myProps.templete_data_json || {};

  const get_word_list_row_tags = () => {
    let row_tags: any = [];
    let word_arr = templete_data_json.word_arr || [];
    let repeat_cnt = templete_data_json.repeat_cnt || 1;
    let word_idx = 0;
    let word_repeat_idx = 0;

    for (let row_i = 0; row_i < templete_data_json.row_cnt; row_i++) {
      let col_tags: any = [];
      for (let col_i = 0; col_i < templete_data_json.col_cnt; col_i++) {
        let td_word_str = "";
        let td_word_mean = "";

        if (word_repeat_idx % repeat_cnt == 0) {
          if (word_idx < word_arr.length) {
            let word_data = word_arr[word_idx];
            if(templete_data_json.is_print_word){
              td_word_str = word_data.a_word;
            }
            if (templete_data_json.is_print_mean) {
              td_word_mean = word_data.a_mean;
            }
            word_idx++;
          }
        }
        word_repeat_idx++;
        let td_class_name = Style.word_box_td_con;
        let word_mean_div: any = "";
        word_mean_div = (
          <div className={Style.word_box_td_con_mean}>
            {td_word_mean}
          </div>
        );

        let td_word_style: any = {};
        if (td_word_str.length > 10) {
          td_word_style.fontSize = "15px";
        }

        col_tags.push(
          <td key={col_i}>
            <div className={td_class_name} style={td_word_style}>
              {td_word_str}
              {word_mean_div}
            </div>
          </td>
        );
      }

      let col_width_per = 100 / templete_data_json.col_cnt;

      row_tags.push(
        <div key={row_i} className={Style.word_box_list_row}>
          <table>
            <colgroup>
              {col_tags.map((col_tag: any, col_i: number) => (
                <col key={col_i} style={{ width: `${col_width_per}%` }} />
              ))}
            </colgroup>
            <tbody>
              <tr>
                {col_tags}
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    return row_tags;
  };

  return (
    <div className={Style.word_box_list_wrap}>
      {get_word_list_row_tags()}
    </div>
  );
};
export default WordListArea;